import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import ReactGA from "react-ga";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import "../Styles/commisions.css";
import Alert from "../components/Alert";

ReactGA.pageview(window.location.pathname + window.location.search);

const Commisions = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    artworkType: "",
    size: "",
    stylePreferences: "",
    referenceImage: null,
    message: "",
  });
  const [alert, setAlert] = useState({status: "", message: ""});

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value, // handle file input for ReferenceImg
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Create FormData object and append fields
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });
    try {
      const response = await axios.post(
        "https://sawaapi.space/api/v1/commissions/send-commission",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        const message = "Commission request sent successfully!";
        setAlert({ status: "success", message: message });
        setFormData({
          name: "",
          email: "",
          phone: "",
          country: "",
          artworkType: "",
          size: "",
          stylePreferences: "",
          referenceImage: null,
          message: "",
        });
      } else {
        alert("Failed to send commission request.");
      }
    } catch (error) {
      const errorMessage = "There was an error sending your request. Please try again later.";
      setAlert({ status: "error", message: errorMessage });
    }
  };
  return (
    <div className="commisions">
      <Helmet>
        <title>SAWA | Commisions</title>
        <meta name="description" content="" />
        <link rel="canonical" href="/about-sawa" />
      </Helmet>
      <NavBar />
      {alert.message && (
        <Alert
          status={alert.status}
          message={alert.message}
          onClose={() => setAlert({ status: "", message: "" })}
        />
      )}
      <section className="relative h-[80vh] flex flex-col justify-center items-center text-white">
        <img
          src='https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_2000/o7dcbihdurtltxetdegl.webp'
          alt="Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          style={{ filter: 'brightness(0.3)' }} 
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-0 z-10"></div>
        <div
          className="relative z-20 text-center px-4 sm:px-6 lg:px-8"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-semibold mb-4">
            Commissions
          </h1>
          <p className="max-w-lg font-poppins mt-10 sm:max-w-xl md:max-w-2xl lg:max-w-4xl font-light mx-auto text-lg sm:text-xl md:text-2xl text-bold">
            Own a piece of art that tells your story. Commission your artwork
            today.
          </p>
        </div>
        <div className="absolute top-0 left-0 w-full h-full border-l-[1px] border-b-[3px] border-white z-30"></div>
      </section>
      <div className="steps font-poppins">
        <p>
          A commission is a unique piece of art created specifically for
          you. It’s a personalized work of art that reflects your
          taste,style, and preferences. Whether you have a particular image in
          mind, a cherished memory, or simply a desire for a custom artwork, our
          talented artists can bring your vision to life.
        </p>
        <h2 data-aos="fade-in" data-aos-duration="200">
          How it works
        </h2>
        <ol>
          <li data-aos="fade-in" data-aos-duration="600">
            {" "}
            <span>Share Your Inspiration</span> : Collaborate with us to share
            your ideas. This could be a photo, a sketch, or simply a description
            of what you envision.{" "}
          </li>
          <li data-aos="fade-in" data-aos-duration="600">
            {" "}
            <span> Choose Your Image </span>: If you prefer, select a wildlife
            image from our collection or provide your own. This will serve as
            the foundation for your custom artwork.
          </li>
          <li data-aos="fade-in" data-aos-duration="600">
            {" "}
            <span> Fill Out the Commission Form </span>: Our commission form
            guides you through the process, capturing essential details about
            your desired artwork.
          </li>
          <li data-aos="fade-in" data-aos-duration="600">
            {" "}
            <span> We Bring Your Vision to Life </span>: Once we receive your
            commission, our artists will begin creating a masterpiece tailored
            to your specifications.
          </li>
          <li data-aos="fade-in" data-aos-duration="600">
            {" "}
            <span> Delivery and Enjoyment </span>: Upon completion, you will be
            notified, and your artwork will be carefully prepared for delivery.
          </li>
        </ol>
      </div>
      {/* <div className="middle">
        <div className="cards">
          <div
            className="card"
            data-aos="fade-in"
            data-aos-duration="500"
            data-aos-delay={500}
          ></div>
          <div
            className="card"
            data-aos="fade-in"
            data-aos-duration="500"
            data-aos-delay={600}
          ></div>
          <div
            className="card"
            data-aos="fade-in"
            data-aos-duration="500"
            data-aos-delay={700}
          ></div>
        </div>
        <div className="SecondSteps">
          <p data-aos="fade-in" data-aos-duration="600">
            Lorem ipsum dolor sit amet consectetur. Commodo vulputate malesuada
            lectus phasellus at turpis ac. Aenean etiam in volutpat risus eu
            metus eros turpis. Quis sit nulla augue velit. Lorem ipsum dolor sit
            amet consectetur. Commodo vulputate malesuada lectus phasellus at
            turpis ac. Aenean etiam in volutpat risus eu metus eros turpis. Quis
            sit nulla augue velit.{" "}
          </p>
        </div>
      </div> */}
      <div className="TheForm">
        <div className="top">
          <h1 data-aos="fade-up" data-aos-duration="200">
            Fill out this form
          </h1>
        </div>
        <form onSubmit={handleSubmit}>
          <h4 data-aos="fade-in" data-aos-duration="600">
            Artist Commission Request{" "}
          </h4>
          <div className="inputs" data-aos="fade-in" data-aos-duration="600">
            <div className="input-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={handleChange}
                name="name"
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                value={formData.email}
                onChange={handleChange}
                name="email"
                required
              />
            </div>
          </div>
          <div className="inputs" data-aos="fade-in" data-aos-duration="600">
            <div className="input-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                name="phone"
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="country">Country Of Residence</label>
              <input
                type="text"
                value={formData.country}
                onChange={handleChange}
                name="country"
                required
              />
            </div>
          </div>
          <div className="inputs" data-aos="fade-in" data-aos-duration="600">
            <div className="input-group">
              <label htmlFor="artworkType">ArtWork Type</label>
              <input
                type="text"
                value={formData.artworkType}
                onChange={handleChange}
                name="artworkType"
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="size">Size</label>
              <input
                type="text"
                value={formData.size}
                onChange={handleChange}
                name="size"
                required
              />
            </div>
          </div>
          <div className="inputs" data-aos="fade-in" data-aos-duration="600">
            <div className="input-group">
              <label htmlFor="stylePreferences">Styles Preference</label>
              <input
                type="text"
                value={formData.stylePreferences}
                onChange={handleChange}
                name="stylePreferences"
                required
              />
            </div>
            <div className="input-group">
              <label htmlFor="referenceImage">Reference Image</label>
              <input
                type="file"
                onChange={handleChange}
                name="referenceImage"
                accept="image/*"
                // required
              />
            </div>
          </div>
          <div className="textArea" data-aos="fade-in" data-aos-duration="600">
            <label htmlFor="message">Specific Requests</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Put in specific details or elements you want to be included"
              required
            ></textarea>
            <button type="submit" data-aos="fade-up" data-aos-duration="200">
              Submit
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};
export default Commisions;
